import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/pro-solid-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type {
  AgencyModel,
  FavouriteOrderItemModel,
  ProviderModel,
  ProviderPriceListItemModel,
  ProviderPriceListItemOptionModel,
  ServiceProductModel,
} from '@models/types'

import useFavouriteOrderButton from './hooks/useFavouriteOrderButton'

interface ToggleFavouriteOrderButtonProps {
  agency: AgencyModel,
  favouriteOrderItem?: FavouriteOrderItemModel,
  filters: {
    agency_id: number,
    options_string: string,
    provider_price_list_item_id: number,
  },
  orderTotal: number,
  provider: ProviderModel,
  providerPriceListItem: ProviderPriceListItemModel,
  providerPriceListItemOptions: ProviderPriceListItemOptionModel[],
  serviceProduct: ServiceProductModel,
}

const ToggleFavouriteOrderButton = (props: ToggleFavouriteOrderButtonProps) => {
  const {
    agency,
    favouriteOrderItem,
    filters,
    orderTotal,
    provider,
    providerPriceListItem,
    providerPriceListItemOptions,
    serviceProduct,
  } = props

  const favouriteOrderButtonPayload = useFavouriteOrderButton({
    agency,
    favouriteOrderItem,
    filters,
    orderTotal,
    provider,
    providerPriceListItem,
    providerPriceListItemOptions,
    serviceProduct,
  })

  const {
    callbacks: {
      createFavouriteOrder,
      deleteFavouriteOrder,
    },
    loading,
    matchedFavouriteItem,
  } = favouriteOrderButtonPayload

  if (matchedFavouriteItem?.id){
    return (
      <Button
        buttonStyle="primaryEdit"
        icon={<FontAwesomeIcon icon={faHeart} />}
        loading={loading}
        onClick={() => deleteFavouriteOrder()}
        // @ts-expect-error TS2322
        marginRight="medium"
        size="medium"
        width="auto"
      />
    )
  }

  return (
    <Button
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={faHeart} />}
      loading={loading}
      onClick={() => createFavouriteOrder()}
      // @ts-expect-error TS2322
      marginRight="medium"
      size="medium"
      width="auto"
    />
  )
}

export default ToggleFavouriteOrderButton
